export default function marqueeInit() {
  const marquee = document.querySelectorAll('.marquee');

  marquee.forEach((element) => {
    const marqueeContent = element.querySelector('.marquee-content');

    if (!marqueeContent) return;

    const marqueeContentWidth = marqueeContent.offsetWidth;
    const duration = (40 * marqueeContentWidth) / 800;

    setTimeout(() => {
      element.style.setProperty('--marquee-animation-duration', `${duration}s`);
      element.style.opacity = '1';
    }, 1000);
  });
}
